<template>
    <v-card>
      <v-container style="max-width: 1500px">
        <v-row>
          <v-col cols="12">
            <v-toolbar color="secondary" flat dense>
              <v-toolbar-title>Prices</v-toolbar-title>
            </v-toolbar>
          </v-col>
        </v-row>
  
        <v-row class="shortcuts-padding"> 
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="12"
          >
            <v-row dense>
              <v-col cols="12" md="3">
                <v-btn to="/non-uom-price-list" text  left
                  ><v-icon left>mdi-list-box-outline</v-icon>Default Price List</v-btn
                ><br />
                
                <v-btn to="/uom-price-list" text  left
                  ><v-icon left>mdi-list-box-outline</v-icon> Uom Products Prices</v-btn
                ><br />

              </v-col>
  
            </v-row>
          </v-col>
  
        </v-row>
  
        <snackbar ref="snackbar"></snackbar>
      </v-container>
    </v-card>
  </template>
  
  
  <script>
  export default {
    components: {},
    computed: {
      role() {
        return localStorage.getItem("userRole");
      },
    },
    data() {
      return {
        loader: false,
        loading: false,
      };
    },
    methods: {
    },
    created() {
  
    },
  };
  </script>
  
  <style>
  .small {
    max-width: 600px;
    margin: 150px auto;
  }
  
  .cardText {
    font-weight: bold;
    font-size: 18px;
    padding: 12px;
    color: #757575;
  }
  
  .dash-btn {
    margin-top: -5px;
  }
  </style>